import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const Login = () => import('./components/Login')
const Home = () => import('./components/Home')
const ImageList = () => import('./components/ImageList')
const HuashuEdit = () => import('./components/HuashuEdit')
const HuashuImport = () => import('./components/HuashuImport')
const Download = () => import('./components/Download')
const TestPC = () => import('./components/TestPC')

const routes = [
    // {
    //     path: '/',
    //     name: 'download', 
    //     component: Download,
    //     meta: {
    //         keepAlive: false
    //     }
    // },
    // {path: '*', redirect: '/' }
    
    // {
    //     path: '/',
    //     name: 'login', 
    //     component: Login,
    //     meta: {
    //         keepAlive: false
    //     }
    // },
    {
        path: '/login',
        name: 'login', 
        component: Login,
        meta: {
            keepAlive: false
        }
    },
    {   
        path: '/home', 
        name: 'home', 
        component: Home,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/imageList',
        name: 'imageList', 
        component: ImageList,
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/huashuEdit',
        name: 'huashuEdit', 
        component: HuashuEdit,
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/huashuImport',
        name: 'huashuImport', 
        component: HuashuImport,
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/',
        name: 'download', 
        component: Download,
        meta: {
            keepAlive: false
        }
    },
    {path: '*', redirect: '/' }
    // {
    //     path: '/download',
    //     name: 'download', 
    //     component: Download,
    //     meta: {
    //         keepAlive: false
    //     }
    // },
    // {
    //     path: '/testpc',
    //     name: 'testpc', 
    //     component: TestPC,
    //     meta: {
    //         keepAlive: false
    //     }
    // },
];

const router = new VueRouter({
    routes,
    mode:'history',
    base:'/pc'
});

//router.beforeEach()
export default router